import {apiFetch} from 'lib/fetch'
import type {FinancialExport} from 'types/financialExport'

export const list = async (uri: string): Promise<FinancialExport[]> =>
  apiFetch.get<FinancialExport[]>(uri)
